export default {
  'login.banner.title': '',
  'login.banner.desc': '',
  'login.form.title': '登录',
  'login.form.username.placeholder': '请输入用户名',
  'login.form.username.rule': '请输入用户名',
  'login.form.password.placeholder': '请输入密码',
  'login.form.password.rule': '请输入密码',
  'login.form.captcha.placeholder': '请输入验证码',
  'login.form.captcha.rule': '请输入验证码',
  'login.form.captcha.refresh': '刷新验证码',
  'login.form.remember.label': '记住我',
  'login.form.submit': '登 录',
}
